import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["quantityFields", "lotFields", "catchWeightFields", "locationInput", "binInput"]
    static values = {
        trackingTypeUrl: String
    }

    connect() {
        this.variantInput = this.element.querySelector("input[name='stock_entry[item_variant_id]']")
        this.hideAll()
        this.variantChanged()
        this.locationChanged()
    }

    hideAll() {
        this.disableInputs(this.quantityFieldsTarget)
        this.disableInputs(this.lotFieldsTarget)
        this.disableInputs(this.catchWeightFieldsTarget)
    }

    async locationChanged() {
        console.log("location changed")
        this.selectLocation(this.locationInputTarget.value)
    }

    selectLocation(locationId) {
        this.binInputTargets.forEach(bin => {
            if (bin.dataset.locationId === locationId) {
                bin.disabled = false
                bin.closest(".row").classList.remove("d-none")
            } else {
                bin.disabled = true
                bin.closest(".row").classList.add("d-none")
            }
        })
    }

    async variantChanged() {
        console.log("variant changed")
        const variantId = this.variantInput.value
        if (!variantId) {
            this.hideAll()
            return
        }

        const response = await fetch(`${this.trackingTypeUrlValue}?item_variant_id=${variantId}`)
        const data = await response.json()
        const trackingType = data.tracking_type

        // show relevant fields
        this.hideAll()
        switch (trackingType) {
            case "none":
            case "quantity":
                break
            case "location_quantity":
                this.enableInputs(this.quantityFieldsTarget)
                break
            case "lot":
            case "lot_tracked":
                this.enableInputs(this.lotFieldsTarget)
                break
            case "catch_weight":
            case "catch_weighted":
                this.enableInputs(this.catchWeightFieldsTarget)
                break
        }
    }

    disableInputs(container) {
        container.classList.add("d-none")
        container.querySelectorAll("input, select, textarea").forEach(el => {
            el.disabled = true
        })
    }

    enableInputs(container) {
        container.classList.remove("d-none")
        container.querySelectorAll("input, select, textarea").forEach(el => {
            el.disabled = false
        })
    }
}
